module.exports = "./img/72b31bfb65391718d9813c874165797c.png";